import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FileManagerViewModule } from '../file-manager/file-manager-view/file-manager-view.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { DxAccordionModule, DxBoxModule, DxToolbarModule, DxTabPanelModule } from 'devextreme-angular';
import { MatTabsModule } from '@angular/material/tabs';
import { ImageOrganizerModule } from './image-organizer/image-organizer.module';
import { DxTagBoxModule, DxTemplateModule } from 'devextreme-angular';
import { ImageCollageModule } from './image-collage/image-collage.module';
import { SelectSourceDlgComponent } from './select-source-dlg/select-source-dlg.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScanSetupDlgComponent } from './scan-setup-dlg/scan-setup-dlg.component';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';
import { ChangeImageDateDialogComponent } from './change-image-date-dialog/change-image-date-dialog.component';

@NgModule({
    declarations: [
        SelectSourceDlgComponent,
        ScanSetupDlgComponent,
        ChangeImageDateDialogComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ImageCollageModule,
        ImageOrganizerModule,
        FileManagerViewModule,
        DragDropModule,
        MatProgressSpinnerModule,
        DxAccordionModule,
        MatCheckboxModule,
        MatGridListModule,
        MatButtonModule,
        MatDialogModule,
        MatCardModule,
        MatDividerModule,
        BrowserAnimationsModule,
        DxBoxModule,
        DxToolbarModule,
        MatSelectModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        DxTabPanelModule,
        MatTabsModule,
        DxTagBoxModule,
        DxTemplateModule,
        TdoControlsModule,
    ],
    exports: []
})
export class ImagingModule { }
